exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  height: 100vh;\n}\n", ""]);

// exports
